import { ICellRendererParams } from '@ag-grid-community/core'
import { Button } from 'components/common'
import Modal from 'components/modal'
import toast from 'react-hot-toast'
import { deleteStore } from 'utils/api/storeApi'

type Props = {
  isOpen: boolean
  closeModal: () => void
  params?: ICellRendererParams
}

const ConfirmDeleteStoreModal = ({ params, closeModal, isOpen }: Props) => {
  // close the modal and untick the delete store checkbox
  const cancelDeleteStore = () => {
    if (params?.data?._id) {
      const rowNode = params.api.getRowNode(params.data._id)
      rowNode?.setSelected(false)
    }
    closeModal()
  }

  // delete the store and remove from table
  const handleDeleteStore = async () => {
    if (params?.data?._id) {
      const deleteToast = toast.loading('Deleting Store...', {
        duration: Infinity,
      })
      try {
        // deleting store api
        await deleteStore(params.data._id)

        // remove row from table
        const rowNode = params.api.getRowNode(params.data._id)
        params.api.applyTransaction({ remove: [rowNode?.data] })

        // toast.success(`${params?.data?._id} Store Deleted Successfully!`, {
        //   duration: 3000,
        // })
        toast.success(`Data Deletion for ${params?.data?._id} Initiated!`, {
          duration: 3000,
          id: deleteToast,
        })

        // closing modal
        closeModal()
      } catch (error) {
        toast.error('Failed to delete store.', {
          duration: 3000,
          id: deleteToast,
        })
      }
    }
  }

  return (
    <Modal
      width={550}
      title={`Confirm delete "${params?.data?.storeName}" ?`}
      titleClassname="text-xl font-semibold max-w-xl"
      isOpen={isOpen}
      closeModal={cancelDeleteStore}
      customStyle={{
        padding: '25px 40px',
      }}
    >
      <>
        <div>
          Deleting <strong>{params?.data?.storeName}</strong> store will remove
          all associated data from{' '}
          <strong className="text-error">Pricing</strong>,{' '}
          <strong className="text-error">Magento API</strong>,{' '}
          <strong className="text-error">Aggregator API</strong>,{' '}
          <strong className="text-error">FTP Configurations</strong>, and{' '}
          <strong className="text-error">Inventory</strong>. Are you sure you
          want to proceed with the deletion?
        </div>

        {/* Actions */}
        <div className="mt-6 flex  w-full items-center gap-5">
          <Button
            onClick={handleDeleteStore}
            className="w-full"
            buttonText="Confirm"
            type="button"
          />
          <Button
            className="w-full"
            buttonText="Cancel"
            variant="outline"
            type="button"
            onClick={cancelDeleteStore}
          />
        </div>
      </>
    </Modal>
  )
}

export default ConfirmDeleteStoreModal
